import { loadGSAP } from '../../externals/gsap.js';

export const defaults = {
  direction: 'up',         // up | down | left | right
  duration: 1,
  delay: 0,
  ease: 'power4.inOut',
};

// direction → [clipPath from, clipPath to]
// inset(top right bottom left)
const CLIPS = {
  up:    ['inset(100% 0 0% 0)', 'inset(0% 0 0% 0)'],
  down:  ['inset(0% 0 100% 0)', 'inset(0% 0 0% 0)'],
  left:  ['inset(0 100% 0 0%)', 'inset(0 0% 0 0%)'],
  right: ['inset(0 0% 0 100%)', 'inset(0 0% 0 0%)'],
};

export default async function reveal(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const duration = parseFloat(options.duration);
  const delay    = parseFloat(options.delay);
  const { direction, ease } = options;

  const [from, to] = CLIPS[direction] ?? CLIPS.up;

  gsap.fromTo(el,
    { clipPath: from },
    { clipPath: to, duration, delay, ease },
  );
}
